import { Component, Vue } from "vue-property-decorator";

@Component
export class LinkMixin extends Vue {
  public goToLink(link?: string, target = "_blank"): void {
    if (!link) return;

    const a = document.createElement("a");
    a.href = link;
    a.target = target;
    a.click();
  }
}
